<template>
  <!-- 옵션 품절 — 값(`value`)은 저장이 성공한 뒤에만 바뀐다. 누르는 순간에는 요청만 나가고 스위치는 그대로다 -->
  <el-switch :value="value" active-color="#f56c6c" @change="toggle"></el-switch>
</template>

<script>
import { MENU_BOARD_OPT_STOP_SELLING_API } from '@/utils/deliveryMenuSync'
import { latestGuard } from '@/utils/latestGuard'
import { saveOptStopSelling } from '@/utils/optStopSelling'

/**
 * **옵션 품절 토글 한 곳** — 점주 「옵션 관리」(`SMenuOptGroupForStoreView`)와 사업장 관리자·관리점·운영사의 「옵션 관리」
 * (`SMenuOptListView`)가 같은 토글을 쓴다. 저장은 그룹 브로드캐스트 API(`POST /api/menu-board/opt-stop-selling`) 하나이고
 * 범위는 서버가 본다(`CatalogScopeGate` — 범위 밖·없는 옵션은 404). 점주 화면에만 있던 동안 대행 계정의 「품절」은 메뉴
 * 단위만 성립했다(R-S).
 *
 * 성공하면 `input` 으로 새 값을 올리고(`v-model`), 실패하면 원래 값을 올린다 — 행의 값은 화면의 것이다. 판정·문구와 요청의
 * 수명은 `utils/optStopSelling` 이 갖고, 여기서는 화면의 사건을 그 가드에 잇는다: 표가 이 토글을 다른 옵션의 줄에 다시 쓰면
 * (옵션 코드가 바뀌면) 나가 있던 응답을 버리고, 토글이 사라지면 닫는다. 화면이 행 키를 주지 않아도 안전해야 한다 — 토글은
 * 어느 표에 놓일지 고르지 않는다. 응답 전의 다시 누름은 나가 있는 저장에 합쳐진다(진행 중 저장 칸 `inFlight` 은 이 인스턴스의
 * 것이다) — 기다리는 동안 스위치를 잠그거나 흐리게 하지 않는다.
 *
 * 세션 액션 판정(`MENU_BOARD_WRITE_ACTION`)은 토글을 그리는 화면이 한다: 액션이 없으면 열째 없어야 해서다.
 */
export default {
  name: 'OptStopSellingSwitch',

  props: {
    /** 옵션 코드 — 저장 본문의 `smenuOptCd` */
    smenuOptCd: { type: Number, required: true },
    /** 지금 품절인가(`v-model`) */
    value: { type: Boolean, default: false },
  },

  data: function () {
    return {
      /** 이 토글이 보낸 저장의 회차 — 늦게 온 응답이 지금 그리는 옵션의 것인지 판정한다(`utils/latestGuard`) */
      guard: latestGuard(),
      /** 이 토글의 진행 중 저장(얼린 `{token, stopSelling, done}` 또는 없음) — 다시 누름을 합치는 근거(`utils/optStopSelling`) */
      inFlight: null,
    }
  },

  watch: {
    // 다른 옵션의 줄에 다시 쓰였다 — 앞 옵션으로 보낸 저장의 응답은 이 옵션의 값도 안내도 아니다
    smenuOptCd: function () {
      this.guard.invalidate()
    },
  },

  // 떠난 토글은 아무것도 반영하지 않는다(되돌아가지 않는다). 이미 보낸 저장은 서버에서 끝난다 — 버림은 화면 반영만 막는다
  beforeDestroy: function () {
    this.guard.close()
  },

  methods: {
    toggle: function (val) {
      return saveOptStopSelling(
        {
          guard: this.guard,
          inFlight: {
            read: () => this.inFlight,
            write: (entry) => {
              this.inFlight = entry
            },
          },
          send: () =>
            this.$axios.post(MENU_BOARD_OPT_STOP_SELLING_API, {
              smenuOptCd: this.smenuOptCd,
              stopSelling: val,
              stopReasonCd: null,
            }),
          t: (key) => this.$t(key),
          apply: (outcome) => {
            this.$emit('input', outcome.value)
            this.$message(outcome.message)
          },
        },
        val
      )
    },
  },
}
</script>
